export const Read = (name) => {
    var nameequal = name + "=";
    var cookies = document.cookie.split(';');

    for (var i = 0; i < cookies.length; i++) {
        var current = cookies[i];

        while (current.charAt(0) == ' ') {
            current = current.substring(1, current.length);
        }

        if (current.indexOf(nameequal) == 0) {
            return current.substring(nameequal.length, current.length);
        }
    }

    return null;
}


// WEBPACK FOOTER //
// ./Statics/scripts/paywall/helpers/cookies.js